import { http } from '../util/http';

export default class SignupStatsService {
	static fetchSignupStats(body) {
		return http.post(`/analytics/signup-stats`, body);
	}
}
